// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__19V2y","select":"Header_select__Fw4St","clinic":"Header_clinic__zwOn5"};